import React from 'react';
import { Icon, Message } from 'semantic-ui-react';
import { Button, Modal } from '../../../../components';
import { FormattedMessage } from 'react-intl';
import { AdministratorForm } from '../form';

import type { ReduxForm } from '../../../../type.js';

type PersonalInformationProps = {
    onClose: Function,
} & ReduxForm;

const PersonalInformation = ({
    onClose,
    handleSubmit,
    submitting,
    pristine,
    readOnly,
    administrator,
    ...props
}: PersonalInformationProps) => (
    <Modal.Context>
        <Modal.Content>
            {!administrator.phone && (
                <Message error>
                    <Icon name="warning sign" />
                    <FormattedMessage
                        id="pages.administrators.form.phoneRequired"
                        defaultMessage="Please enter a valid phone number"
                    />
                </Message>
            )}
            <AdministratorForm
                {...props}
                handleSubmit={handleSubmit}
                submitting={submitting}
                pristine={pristine}
                readOnly={readOnly}
                mode="edit"
            />
        </Modal.Content>
        <Modal.Actions>
            <Button
                onClick={handleSubmit}
                disabled={pristine || submitting || readOnly}
                loading={submitting}
                primary
            >
                <FormattedMessage
                    id="pages.administrators.form.save"
                    defaultMessage="Save"
                />
            </Button>
            <Button onClick={onClose} disabled={submitting} basic>
                <Icon name="remove" />
                <FormattedMessage
                    id="pages.administrators.form.cancel"
                    defaultMessage="Cancel"
                />
            </Button>
        </Modal.Actions>
    </Modal.Context>
);

export default PersonalInformation;
